import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useGetPrintSettingsForDocumentType = (documentType) => {
  const settings = useSelector(Global.selectPrintSettingsPrintSettings);
  return settings ? settings[documentType] : undefined;
};
